import React from 'react';
import './LandingFAQ.css';

// Define FAQ data
const faqData = [
  {
    question: "What is Texta?",
    answer: "Texta is an AI-powered platform designed to streamline localization, translation, and copywriting for teams. It helps you write consistently, translate accurately, and manage your content workflow."
  },
  {
    question: "Who is Texta for?",
    answer: "Texta is built for Designers, Copywriters, Localization Managers, Developers, and Product Teams at large who need to create and manage multilingual content efficiently."
  },
  {
    question: "How does the AI translation work?",
    answer: "We utilize state-of-the-art AI models to provide fast and contextually accurate translations. You can then review and refine these translations within the platform."
  },
  {
    question: "What file formats can I import/export?",
    answer: "Texta supports common formats like JSON, .strings (iOS), and strings.xml (Android) for easy import and export."
  },
  {
    question: "Can I collaborate with my team?",
    answer: "Yes! Texta includes features for team collaboration, including inviting members, assigning roles, managing reviews, and tracking project status."
  },
  {
    question: "Is there a free trial?",
    answer: "Yes, we offer a free trial so you can explore Texta's features before committing. Sign up to get started!"
  },
  {
    question: "How does Texta handle placeholders and variables?",
    answer: "Texta uses a universal placeholder system, allowing you to define variables once and have them correctly formatted for export across different platforms (iOS, Android, Web, etc.)."
  },
  {
    question: "Is my data secure?",
    answer: "Data security is a top priority. We employ industry-standard security measures to protect your content and user information. Importantly, your data is never used to train our AI models. Please refer to our Privacy Policy for more details."
  },
  {
    question: "How does Texta ensure translation quality?",
    answer: "While AI provides the initial translation, Texta includes a review workflow where team members can verify and edit translations. Additionally, you can utilize our Tone of Voice feature to ensure the translation aligns perfectly with your brand's style and cultural context, further enhancing quality."
  },
  {
    question: "Can I automate the translation process?",
    answer: "Yes, Texta offers an API that allows you to fetch completed translations and integrate them into your existing workflows, such as your CI/CD pipeline, for automated content updates."
  }
];

const LandingFAQ = () => {
  return (
    <section id="faq" className="landing-faq-section">
      <div className="landing-faq-title-column">
        <h2 className="landing-faq-title">Frequently Asked Questions</h2>
      </div>
      <div className="landing-faq-content-column">
        <div className="landing-faq-list">
          {faqData.map((item, index) => (
            <div key={index} className="landing-faq-item">
              <h3 className="landing-faq-question">{item.question}</h3>
              <p className="landing-faq-answer">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingFAQ; 